module.exports = __webpack_public_path__ + "img/gcp.5b78c1fa.svg";